
export const constants = {
    GET_TEMPLATES: {
      REQUEST: 'DEV_GET_TEMPLATES_REQUEST',
      SUCCESS: 'DEV_GET_TEMPLATES_SUCCESS',
      FAILURE: 'DEV_GET_TEMPLATES_FAILURE',
    },
    GET_PRIMITIVAS: {
      REQUEST: 'DEV_GET_PRIMITIVAS_REQUEST',
      SUCCESS: 'DEV_GET_PRIMITIVAS_SUCCESS',
      FAILURE: 'DEV_GET_PRIMITIVAS_FAILURE',
    },
    GET_OPERACIONES: {
      REQUEST: 'DEV_GET_OPERACIONES_REQUEST',
      SUCCESS: 'DEV_GET_OPERACIONES_SUCCESS',
      FAILURE: 'DEV_GET_OPERACIONES_FAILURE',
    },
    GET_CONNECTION_TYPES: {
      REQUEST: 'DEV_GET_CONNECTION_TYPES_REQUEST',
      SUCCESS: 'DEV_GET_CONNECTION_TYPES_SUCCESS',
      FAILURE: 'DEV_GET_CONNECTION_TYPES_FAILURE',
    },
    GET_NODE_TYPES: {
      REQUEST: 'DEV_GET_NODE_TYPES_REQUEST',
      SUCCESS: 'DEV_GET_NODE_TYPES_SUCCESS',
      FAILURE: 'DEV_GET_NODE_TYPES_FAILURE',
    },
    OPEN_TAB2: {
      REQUEST: 'DEV_OPEN_TAB_REQUEST',
      SUCCESS: 'DEV_OPEN_TAB,_SUCCESS',
      FAILURE: 'DEV_OPEN_TAB,_FAILURE',
    },
    RELOAD_ITEM: {
      REQUEST: 'DEV_RELOAD_ITEM_REQUEST',
      SUCCESS: 'DEV_RELOAD_ITEM,_SUCCESS',
      FAILURE: 'DEV_RELOAD_ITEM,_FAILURE',
    },
    REMOVE_ITEM: {
      REQUEST: 'DEV_REMOVE_ITEM_REQUEST',
      SUCCESS: 'DEV_REMOVE_ITEM,_SUCCESS',
      FAILURE: 'DEV_REMOVE_ITEM,_FAILURE',
    },
    OPEN_TAB: 'DEV_OPEN_TAB',
    SET_EXPLORER_WIDTH: 'DEV_SET_EXPLORER_WIDTH',
    CLOSE_TAB: 'DEV_CLOSE_TAB',
    SELECT_TAB: 'DEV_SELECT_TAB',
    SET_CHANGED_TAB: 'DEV_SET_CHANGED_TAB',
    SELECT_NODE: 'DEV_SELECT_NODE',
    RELOAD_LOCAL_ITEM: 'DEV_RELOAD_LOCAL_ITEM',
    UPDATE_TAB_TEMPLATE: 'DEV_UPDATE_TAB_TEMPLATE',
    UPDATE_TAB_PRIMITIVA: 'DEV_UPDATE_TAB_PRIMITIVA',
    UPDATE_TAB_ORQUESTADOR: 'DEV_UPDATE_TAB_ORQUESTADOR',
    UPDATE_TAB_DATA: 'DEV_UPDATE_TAB_DATA',
    UPDATE_EXPLORER_DATA: 'DEV_UPDATE_EXPLORER_DATA',
    UPDATE_EXPLORER_DATA_OPEN_FILES: 'DEV_UPDATE_EXPLORER_DATA_OPEN_FILES',
    CREATE_NEW_FILE: 'DEV_CREATE_NEW_FILE',
    CANCEL_NEW_FILE: 'DEV_CANCEL_NEW_FILE',
    CONFIRM_NEW_FILE: 'DEV_CONFIRM_NEW_FILE',
    SAVED_NEW_FILE: 'DEV_SAVED_NEW_FILE',
    SELECT_NODE_FILE: 'DEV_SELECT_NODE_FILE',
    SET_EXPANDED_FOLDER: 'DEV_SET_EXPANDED_FOLDER',
    POST_ADD_ITEM: 'DEV_POST_ADD_ITEM',
    CHANGE_NAVIGATOR_URL: 'CHANGE_NAVIGATOR_URL',
};
